import * as anchorClasse from '../../styles/communs/anchor.module.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

const Anchor = ({anchor, ...props}) => {
  if (anchor) {
    if (anchor.charAt(0) !== '#') {
      anchor = `#${anchor}`;
    }
    const title = props.title || `Section ${anchor}`;
    const clx = props.className || anchorClasse.anchor;
    const onAnchorLinkClick = props.onAnchorLinkClick || undefined;

    return (
      <AnchorLink
        className={clx}
        onAnchorLinkClick={onAnchorLinkClick}
        title={title}
        to={anchor}
      />
    );
  }
  return (
    <>
    </>
  );
};

Anchor.propTypes = {
  anchor: PropTypes.string,
  className: PropTypes.string,
  onAnchorLinkClick: PropTypes.func,
  title: PropTypes.string,
};

export default Anchor;